import React from 'react';
import MetaTags from 'react-meta-tags';


export default class MetaData extends React.Component {
	render() {
		return (
			<MetaTags>
				<title>{this.props.title}</title>
				<meta name="description" content={this.props.descriptionMeta} />
				<meta
					name="keywords"
					content="librairie, chrétien, livre chrétien, évangélique, théologie, Mission Timothée, foi, Connaître Dieu, évangile, protestant, histoire du protestantisme, livre jeunesse, huguenots, bible, bibles, louange, dvd, cd, cadeaux, christianisme, Dieu, Jésus, Jésus-Christ, Avec des cris de joie, spiritualité, enseignement, ressources spirituelles, roman chrétien, saint esprit, librairie protestante"
				/>

			</MetaTags>
		);
	}
}
